// Color de cada ciudad en la gráfica (SVG necesita el color literal, no la variable de CSS).
// MISMOS valores que `--c` de las clases .c-pl-<ciudad> en portal.css (bloque «Colores por etapa» y «Métricas»).
import type { ClaveCiudad } from "@/reclutamiento/ciudades-metricas";

export const COLOR_CIUDAD: Record<"claro" | "oscuro", Record<ClaveCiudad, string>> = {
  claro: {
    monterrey: "#b0466f",
    queretaro: "#2f7a8c",
    cdmx: "#a5622a",
    edomex: "#5f7a26",
    cancun: "#3874a3",
    otra: "#6b7480",
    sin_ciudad: "#9aa3ad",
  },
  oscuro: {
    monterrey: "#94405f",
    queretaro: "#2c6a79",
    cdmx: "#8d5626",
    edomex: "#566e22",
    cancun: "#33658c",
    otra: "#5d6672",
    sin_ciudad: "#48515b",
  },
};

/** Clase de color de la ciudad (pin y borde de la tarjeta). */
export const claseCiudad = (c: ClaveCiudad | null) => (c ? `c-pl-${c}` : "c-todos");
